import Chip from "@mui/material/Chip";
import PublicIcon from "@mui/icons-material/Public";
import { STATUS_STYLES, userStatus } from "./labels";

export function StatusChip({ user }) {
  const status = userStatus(user);
  const style = STATUS_STYLES[status.key];
  return <Chip size="small" label={status.label} sx={{ bgcolor: style.bg, color: style.fg, fontWeight: 600, height: 22, fontSize: 11 }} />;
}

export function ExternalChip() {
  return (
    <Chip
      size="small"
      icon={<PublicIcon />}
      label="Externo"
      variant="outlined"
      sx={{ color: "#ef6c00", borderColor: "#ef6c00", height: 20, fontSize: 11, "& .MuiChip-icon": { color: "#ef6c00", fontSize: 14 } }}
    />
  );
}
